import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../firebase.config";

export function useConnectionHelpStatus() {
  const [isConnectionHelpActive, setIsConnectionHelpActive] = useState(false);

  useEffect(() => {
    const ConnectionHelpStatusRef = ref(database, "connectionHelpStatus");

    const unsubscribe = onValue(ConnectionHelpStatusRef, (snapshot) => {
      const value = snapshot.val();

      console.log("ConnectionHelpStatus value:", value);

      const active = value === true;
      setIsConnectionHelpActive(active);
    }, (error) => {
      console.error("onValue error:", error);
      setIsConnectionHelpActive(false);
    });

    return () => unsubscribe();
  }, []);

  return isConnectionHelpActive;
}
